"use client";

import React from "react";
import { Shield, Zap, HeartHandshake, Sparkles, ChartBar, Globe, Award } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "مبيدات صديقة للبيئة",
  description: "نستخدم تركيبات متطورة تقضي على الآفات بفعالية تامة مع الحفاظ على سلامة البيئة المحيطة وأفراد أسرتك.",
  icon: Shield,
  badge: "معتمد بيئياً"
}, {
  title: "نتائج فورية ومستدامة",
  description: "تتميز حلولنا بسرعة التأثير وطول الأمد، مما يضمن لك منزلاً خالياً من الحشرات لفترات زمنية طويلة جداً.",
  icon: Zap,
  badge: "كفاءة عالية"
}, {
  title: "أمان تام للعائلة",
  description: "جميع المواد المستخدمة معتمدة دولياً ومحلياً، وهي عديمة الرائحة ولا تتطلب مغادرة المنزل أثناء عملية الرش.",
  icon: HeartHandshake,
  badge: "آمن صحياً"
}, {
  title: "تقنيات رش حديثة",
  description: "نعتمد على أحدث أجهزة الرش الألمانية التي تضمن وصول المبيد لأصعب الزوايا والشقوق بدقة متناهية.",
  icon: Sparkles,
  badge: "تكنولوجيا متطورة"
}, {
  title: "تقارير فنية دقيقة",
  description: "نقدم لك تحليلاً شاملاً لمصادر الإصابة مع توصيات وقائية لمنع عودة الآفات مرة أخرى إلى منشأتك.",
  icon: ChartBar,
  badge: "تحليل دقيق"
}, {
  title: "تغطية شاملة بالرياض",
  description: "نصلك أينما كنت في مدينة الرياض من خلال أسطولنا المجهز بالكامل للتعامل مع كافة أنواع الإصابات الحشرية.",
  icon: Globe,
  badge: "خدمة سريعة"
}];
export default function WhyChooseAnnabriel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225518" id="مبيدات-آمنة-وفعالة" className="bg-[var(--color-primary)] text-[var(--text-light)] py-16 md:py-20 lg:py-24 px-4 sm:px-8">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-right max-w-3xl ml-auto mb-16">
          <h2 className="text-[48px] font-bold font-default text-[var(--text-accent)] mb-4 leading-tight">
            مبيدات آمنة وفعالة
          </h2>
          <p className="text-lg text-[var(--text-light)]/80 font-default">
            نجمع بين القوة الفتاكة ضد الآفات والأمان المطلق لصحتكم، باستخدام أجود أنواع المبيدات العالمية المعتمدة.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 relative">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div data-index={i} key={i} className="h-full group transition-all duration-300">
                <Card className="w-[60%] sm:w-[70%] lg:w-[600px] h-[60%] sm:h-[70%] lg:h-[600px] p-4 sm:p-5 lg:p-6 border border-[var(--color-border)]/10 rounded-lg transition-all duration-300 bg-[var(--color-secondary)] backdrop-blur-md hover:bg-[var(--color-secondary)]/80 hover:scale-110 hover:border-[var(--color-accent)] shadow-lg hover:shadow-2xl">
                  <CardHeader className="pb-2 flex-row-reverse text-right items-start justify-between gap-4">
                    <div className="shrink-0 p-3 bg-[var(--color-light-bg)]/5 rounded-lg border border-[var(--color-border)]/10 group-hover:border-[var(--color-accent)] transition-colors">
                      <Icon className="w-8 h-8 text-[var(--text-light)] transition-all duration-300 group-hover:scale-110" strokeWidth={1.5} />
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-[var(--color-accent)]/10 border border-[var(--color-accent)]/20 text-[var(--color-accent)] text-xs font-bold transition-transform duration-300 group-hover:scale-105">
                        <Award className="w-3 h-3" />
                        <span>{benefit.badge}</span>
                      </div>
                      <CardTitle className="font-default text-xl font-bold text-[var(--text-light)] transition-colors duration-300 group-hover:text-[var(--color-accent)]">
                        {benefit.title}
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent className="text-right pt-2">
                    <p className="text-[var(--text-light)]/70 font-default leading-relaxed text-sm">
                      {benefit.description}
                    </p>
                    <div className="mt-4 pt-4 border-t border-[var(--color-border)]/5 flex justify-end">
                      <span className="text-[10px] uppercase tracking-widest text-[var(--text-light)]/30 font-bold">Certified Protection</span>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}